import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import { connect } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { setSuccessMessage } from '../App/ErrorsActions';
import moment from 'moment';

import Header from '../../components/Header/Header';

import { handleError, savePortfolio, listAll as listAllPortfolios } from './PortfolioActions';
import { listAll } from '../ReportConfig/ReportActions';
import throttle from '../../util/throttle';
import { PAGES, trackPageView } from '../../util/mixpanel';

import linkIcon from '../../assets/img/link.svg';
import openInNewIcon from '../../assets/img/open-in-new.svg';
import ValueStreamList from './components/ValueStreamList';

import './PortfolioConfig.scss';

class PortfolioConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selected: [],
      name: ''      
    };

    this.handleTimeChange = throttle(this._handleTimeChange, 1000, this);
  }

  componentDidMount() {
    if (!this.props.streams.length) {
      this.props.getStreams();
    }
    if (!this.props.portfolios.length) {
      this.props.getPortfolios();
    }

    if (!!this.props.portfolio && this.props.params.id && this.props.params.id === this.props.portfolio._id) {
      this.setSettingsState(this.props.portfolio);
    }  

    trackPageView(PAGES.CONFIGURE);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.portfolio, this.props.portfolio)) {
      this.setSettingsState(this.props.portfolio);
    }
    if (prevProps.portfolios != this.props.portfolios) {
      const portfolio = this.props.portfolios.find(d => d._id == this.props.params.id) || {};
      this.setSettingsState(portfolio);
    }
  }

  redirect(id) {
    this.props.router.push(`/portfolios/${id}`);
  }

  setSettingsState(portfolio) {
    this.setState({
      portfolioId: portfolio._id,
      isNew: portfolio.isNew,
      name: portfolio.name,
      url: portfolio.shortUrl,
      wallboardUrl: portfolio.wallboardUrl,
      selected: portfolio.selectedStreams || []      
    });
  }

  handleExcludeWeekendSwitch = () => {
    this.setState({ excludeWeekends: this.state.excludeWeekends === 0 ? 1 : 0 });
  };

  _handleTimeChange = (name, e) => {
    if (!e) {
      return false;
    }

    const newTime = new moment(e, 'HH:mm');

    switch (name) {
      case 'workStart': {
        const endTime = new moment(this.state.workEnd, 'HH:mm');
        if (newTime.isSame(endTime, 'minute')) {
          this.props.handleError(`Starting time should not be equal to Finishing time`);
          return false;
        }
        if (newTime.isAfter(endTime, 'minute')) {
          this.props.handleError(`Starting time should be before Finishing time`);
          return false;
        }
        this.setState({ workStart: e });
        break;
      }
      case 'workEnd': {
        const startTime = new moment(this.state.workStart, 'HH:mm');
        if (newTime.isSame(startTime, 'minute')) {
          this.props.handleError(`Finishing time should not be equal to Starting time`);
          return false;
        }
        if (newTime.isBefore(startTime, 'minute')) {
          this.props.handleError(`Finishing time should be after Starting time`);
          return false;
        }
        this.setState({ workEnd: e });
        break;
      }
    }
  };
  preventSubmit = event => {
    event.preventDefault();
  };

  handleSubmit = event => {
    event.preventDefault();
    if (!this.state.name) {
      this.props.handleError('Name should be filled in');
      return false;
    }
    if (this.state.selected.length < 2) {
      this.props.handleError('Please select at least two value streams');
      return false;
    }    

    const data = {
      portfolioId: this.state.portfolioId,
      isNew: this.state.isNew,
      name: this.state.name,
      selectedStreams: this.state.selected,
      excludeWeekends: +this.state.excludeWeekends,
      workStart: this.state.workStart,
      workEnd: this.state.workEnd
    };

    this.props.save(data).then(res => this.redirect(res._id));
  };

  handleCopied = () => {
    this.props.setSuccess('URL copied');
  };

  handleChange = e => {
    let selected = [...this.state.selected];

    if (!e.checked) {
      let index = selected.indexOf(e.name);
      if (index === -1) {
        index = _.indexOf(selected, e.value);
      }

      selected.splice(index, 1);
    } else {
      selected.push(e.name);
    }

    selected = _.uniq(selected);

    this.setState({ selected });
  };

  renderWallboardUrl() {
    const { wallboardUrl } = this.props.portfolio;
    if (wallboardUrl) {
      return (
        <Form.Group controlId="wallboard-url" className="display_url_input">
          <Form.Label>Wallboard URL</Form.Label>
          <div>
            <Form.Control type="text" name="wallboard-url" value={wallboardUrl} readOnly />
            <CopyToClipboard text={wallboardUrl} onCopy={this.handleCopied}>
              <a className="btn btn-md btn-secondary">
                <img src={linkIcon} alt="#" />
                Copy
              </a>
            </CopyToClipboard>
            <a href={wallboardUrl} target="_blank" className="btn btn-md btn-primary">
              <img src={openInNewIcon} alt="#" />
              Open
            </a>
          </div>
        </Form.Group>
      );
    }
  }

  render() {
    const { url, selected, name, wallboardUrl } = this.state;
    const backUrl = selected._id ? `/portfolios/${selected._id}` : '/portfolios';
    return [
      <Helmet key="1">
        <title>{pageTitle('Portfolio')}</title>  
      </Helmet>,
      <Header key="2" title="" showHome={true} hideReport={true} />,
      <div key="3" className="bg_dashboard config_content">
        <div className="container">
          <Form className="form_content" onSubmit={this.preventSubmit}>
            <div className="btn-action">
              <Link to={backUrl} className="btn btn-secondary btn-prev">
                Back
              </Link>
              <Button variant="primary" type="submit" onClick={this.handleSubmit}>
                {this.props.isLoading ? 'Loading...' : this.props.isNew ? 'Create portfolio' : 'Save changes'}
              </Button>
            </div>
            <div className="form-row-flex">
              <Form.Group controlId="name" className="display_url_input name-field">
                <Form.Label>Portfolio name</Form.Label>
                <div>
                  <Form.Control
                    type="text"
                    name="portfolio-name"
                    value={name}
                    onChange={e => this.setState({ name: e.target.value })}
                    className="name_input"
                  />
                </div>
              </Form.Group>
              {url && (
                <Form.Group controlId="wallboard-url" className="display_url_input wallboard-field">
                  <Form.Label>Wallboard URL</Form.Label>
                  <div>
                    <Form.Control
                      type="text"
                      name="wallboard-url"
                      value={wallboardUrl}
                      readOnly
                    />
                    <CopyToClipboard
                      text={wallboardUrl}
                      onCopy={this.handleCopied}
                    >
                      <a className="btn btn-md btn-secondary">
                        <img src={linkIcon} alt="#" />
                        Copy
                      </a>
                    </CopyToClipboard>
                    <a
                      href={wallboardUrl}
                      target="_blank"
                      className="btn btn-md btn-primary"
                    >
                      <img src={openInNewIcon} alt="#" />
                      Open
                    </a>
                  </div>
                </Form.Group>
              )}
              
            </div>

            <Form.Group controlId="streams">
              <ValueStreamList
                userId={this.props.user._id}
                selectable
                handleChange={this.handleChange}
                selected={selected}
              ></ValueStreamList>
            </Form.Group>
          </Form>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err, { log: false })),
    setSuccess: msg => dispatch(setSuccessMessage(msg, { toastId: 'url_success' })),
    getStreams: () => dispatch(listAll()),
    getPortfolios: () => dispatch(listAllPortfolios()),
    save: data => dispatch(savePortfolio(data))
  };
};

const mapStateToProps = state => {
  return {
    streams: state.report.streams,
    isLoading: state.portfolio.isLoading,
    portfolio: state.portfolio.selectedPortfolio,
    portfolios: state.portfolio.portfolios,
    user: state.auth.user
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioConfig);
